export default {
  "hero.title.line1": "OOPBuy Spreadsheet",
  "hero.title.line2": "Der ultimative Guide",
  "hero.title.line3": "für Deutschland 2026",
  "hero.subtitle": "Finde die besten Produkte, Verkäufer und spare Versandkosten mit dem OOPBuy Spreadsheet – dem kompletten Tool für clevere Shopper in Deutschland.",
  "hero.cta": "Zum Spreadsheet",
  "hero.cta2": "Jetzt kaufen",

  "trust.title": "Warum tausende Deutsche",
  "trust.title2": "auf OOPBuy vertrauen",
  "trust.desc": "Das OOPBuy Spreadsheet ist das vertrauenswürdigste Tool für deutsche Käufer, die Qualität, Sicherheit und die besten Deals suchen.",
  "trust.card1.title": "Geprüfte QC",
  "trust.card1.desc": "Jedes Produkt wird mit detaillierten QC-Fotos vor dem Versand geprüft. So siehst du genau, was du bekommst.",
  "trust.card2.title": "Schneller Versand",
  "trust.card2.desc": "Versand nach Deutschland in 7–14 Tagen mit DHL, UPS und EMS. Alle Zollformalitäten werden für dich übernommen.",
  "trust.card3.title": "Top Verkäufer",
  "trust.card3.desc": "Nur die besten und zuverlässigsten Verkäufer sind im Spreadsheet gelistet. Keine Fake-Bewertungen, keine Scams.",

  "stats.spreadsheets": "200+",
  "stats.spreadsheets.label": "Gelistete Produkte",
  "stats.users": "15.000+",
  "stats.users.label": "Zufriedene Nutzer",
  "stats.sellers": "500+",
  "stats.sellers.label": "Geprüfte Verkäufer",
  "stats.countries": "30+",
  "stats.countries.label": "Lieferländer",

  "categories.title": "Produktkategorien",
  "categories.subtitle": "Entdecke alle",
  "categories.subtitle2": "Kategorien im Spreadsheet",
  "categories.desc": "Durchsuche unsere vollständige Sammlung kuratierter Produkte. Von Sneakers über Hoodies bis Accessoires – hier findest du alles.",

  "shipping.title": "Versand Guide",
  "shipping.heading1": "So funktioniert der",
  "shipping.heading2": "Versand nach",
  "shipping.heading3": "Deutschland",
  "shipping.desc": "Der Versand mit OOPBuy ist einfach und sicher. Erfahre alles über Versandoptionen, Kosten und Lieferzeiten für Deutschland.",
  "shipping.quote": "Mit dem OOPBuy Spreadsheet kannst du bis zu 40% Versandkosten sparen, indem du die richtige Versandlinie für dein Paket auswählst.",
  "shipping.author": "Versand-Experte",
  "shipping.cta": "Mehr erfahren",

  "qc.title": "QC Guide",
  "qc.heading1": "Qualitätskontrolle",
  "qc.heading2": "die du verstehen",
  "qc.heading3": "musst",
  "qc.desc": "QC-Fotos sind deine Versicherung. Lerne, wie du QC-Bilder richtig liest und worauf du achten musst, bevor du den Versand freigibst.",
  "qc.quote": "Gute QC-Fotos zeigen dir jedes Detail: Nähte, Logos, Material. Mit unserem Guide erkennst du sofort, ob ein Produkt top ist oder nicht.",
  "qc.author": "QC-Spezialist",
  "qc.cta": "QC-Guide lesen",

  "safety.title": "Sicherheits Guide",
  "safety.heading1": "100% sicheres",
  "safety.heading2": "Einkaufen mit",
  "safety.heading3": "OOPBuy",
  "safety.desc": "Sicherheit steht an erster Stelle. Erfahre, wie OOPBuy deine Zahlungen schützt und worauf du beim Kauf achten solltest.",
  "safety.quote": "OOPBuy bietet PayPal-Zahlung und Käuferschutz. In Kombination mit unserem Spreadsheet kaufst du immer bei verifizierten, sicheren Verkäufern ein.",
  "safety.author": "Sicherheits-Berater",
  "safety.cta": "Sicherheits-Guide",

  "beginner.title": "Anfänger Guide",
  "beginner.heading1": "Der perfekte Start",
  "beginner.heading2": "für OOPBuy",
  "beginner.heading3": "Einsteiger",
  "beginner.desc": "Neu bei OOPBuy? Kein Problem. Unser Schritt-für-Schritt Anfänger-Guide bringt dich in 10 Minuten zum ersten erfolgreichen Kauf.",
  "beginner.quote": "Von der Registrierung bis zur ersten Bestellung: Mit unserem Anfänger-Guide und dem Spreadsheet machst du null Fehler bei deinem ersten OOPBuy-Einkauf.",
  "beginner.author": "Community Mentor",
  "beginner.cta": "Anfänger-Guide",

  "comparison.title": "Plattform Vergleich",
  "comparison.subtitle": "OOPBuy vs die Konkurrenz",
  "comparison.desc": "Wir haben OOPBuy mit allen großen Alternativen verglichen, damit du die beste Entscheidung treffen kannst.",
  "comparison.card1.title": "OOPBuy",
  "comparison.card1.pro1": "Beste QC-Fotos",
  "comparison.card1.pro2": "Schnellster Versand nach DE",
  "comparison.card1.pro3": "Große Produktauswahl",
  "comparison.card1.pro4": "PayPal-Zahlung möglich",
  "comparison.card2.title": "Pandabuy",
  "comparison.card2.pro1": "Große Community",
  "comparison.card2.pro2": "Einfache Bedienung",
  "comparison.card2.pro3": "Durchschnittliche QC",
  "comparison.card2.pro4": "Höhere Gebühren",
  "comparison.card3.title": "Sugargoo",
  "comparison.card3.pro1": "Günstige Preise",
  "comparison.card3.pro2": "Viele Rabatte",
  "comparison.card3.pro3": "Langsamerer Versand",
  "comparison.card3.pro4": "Weniger Produkte",

  "testimonial.title": "Was unsere Nutzer sagen",
  "testimonial.quote": "Das OOPBuy Spreadsheet hat mein Shopping-Erlebnis komplett verändert. Ich habe über 500€ an Versandkosten gespart und nur Top-Qualität bekommen. Absolut empfehlenswert für jeden, der in Deutschland OOPBuy nutzt.",
  "testimonial.author": "Markus K.",
  "testimonial.role": "OOPBuy Nutzer seit 2023",
  "testimonial.cta": "Mehr Bewertungen",

  "faq.title": "FAQ",
  "faq.heading1": "Häufig gestellte",
  "faq.heading2": "Fragen zum OOPBuy",
  "faq.heading3": "Spreadsheet",
  "faq.desc": "Hier findest du Antworten auf die wichtigsten Fragen rund um das OOPBuy Spreadsheet und den Einkauf über OOPBuy.",
  "faq.q1": "Was ist das OOPBuy Spreadsheet?",
  "faq.a1": "Das OOPBuy Spreadsheet ist eine kuratierte Tabelle mit den besten Produkten, Verkäufern und Links für OOPBuy. Es spart dir Stunden an Recherche und hilft dir, nur bei vertrauenswürdigen Verkäufern zu kaufen. Mit regelmäßigen Updates bleibst du immer auf dem neuesten Stand.",
  "faq.q2": "Wie benutzt man das OOPBuy Spreadsheet?",
  "faq.a2": "Das Spreadsheet ist sehr einfach zu bedienen. Du öffnest es in Google Sheets oder Excel, wählst eine Kategorie aus und klickst auf den Link des gewünschten Produkts. Du wirst direkt zur OOPBuy-Produktseite weitergeleitet. Von dort kannst du das Produkt wie gewohnt bestellen.",
  "faq.q3": "Ist OOPBuy sicher für deutsche Käufer?",
  "faq.a3": "Ja, absolut. OOPBuy ist eine etablierte Plattform mit PayPal-Zahlung und Käuferschutz. Das Spreadsheet listet nur verifizierte Verkäufer mit nachweislich guter Qualität. Zusätzlich erhältst du QC-Fotos vor dem Versand, sodass du genau siehst, was du kaufst.",
  "faq.q4": "Wie finde ich gute Verkäufer auf OOPBuy?",
  "faq.a4": "Gute Verkäufer zu finden ist zeitaufwendig – genau deshalb gibt es unser Spreadsheet. Wir haben hunderte Verkäufer getestet und nur die besten in die Liste aufgenommen. Achte auf Verkäufer mit hohen Bewertungen, echten QC-Fotos und positiven Community-Feedback.",
  "faq.q5": "Wie hoch sind die Versandkosten nach Deutschland?",
  "faq.a5": "Die Versandkosten hängen vom Gewicht und der Versandlinie ab. Mit dem Spreadsheet siehst du, welche Versandlinie für welches Produkt am günstigsten ist. Im Durchschnitt liegen die Kosten zwischen 20€ und 50€ für ein typisches Paket. Mit unseren Tipps sparst du bis zu 40%.",
  "faq.q6": "Wie lange dauert der Versand nach Deutschland?",
  "faq.a6": "Mit DHL und UPS dauert der Versand in der Regel 7–14 Tage nach Deutschland. EMS ist etwas günstiger, braucht aber 10–20 Tage. Im Spreadsheet findest du für jedes Produkt die empfohlene Versandlinie mit der besten Balance aus Geschwindigkeit und Kosten.",
  "faq.q7": "Was ist QC und warum ist es wichtig?",
  "faq.a7": "QC steht für Quality Control (Qualitätskontrolle). Nachdem du ein Produkt bestellt hast, macht OOPBuy Fotos davon im Lager. Du kannst diese QC-Fotos prüfen und entscheiden, ob das Produkt deinen Erwartungen entspricht. Bei Mängeln kannst du es zurücksenden. Das Spreadsheet zeigt dir, worauf du bei QC-Fotos achten musst.",
  "faq.q8": "Kann ich mit PayPal bei OOPBuy bezahlen?",
  "faq.a8": "Ja, OOPBuy akzeptiert PayPal. Das ist die sicherste Zahlungsmethode für deutsche Käufer, da PayPal einen eigenen Käuferschutz bietet. Im Spreadsheet findest du eine Anleitung, wie du PayPal mit OOPBuy verknüpfst.",
  "faq.q9": "Welche Produkte sind im Spreadsheet enthalten?",
  "faq.a9": "Das Spreadsheet enthält 14 Kategorien: Schuhe, Hoodies/Sweaters, T-Shirts, Jacken, Hosen/Shorts, Kopfbedeckungen, Sets, Unterwäsche, Trikots, Accessoires, Taschen, Gürtel, Parfüms und weitere Produkte. Jede Kategorie wird regelmäßig mit neuen Produkten aktualisiert.",
  "faq.q10": "Wie oft wird das Spreadsheet aktualisiert?",
  "faq.a10": "Das Spreadsheet wird monatlich aktualisiert. Wir fügen neue Produkte hinzu, entfernen ausverkaufte Artikel und passen die Verkäufer-Bewertungen an. So bleibst du immer auf dem neuesten Stand mit den besten OOPBuy-Produkten.",
  "faq.q11": "Was kostet das OOPBuy Spreadsheet?",
  "faq.a11": "Das Spreadsheet ist ein einmaliger Kauf. Du zahlst einmal und erhältst lebenslangen Zugriff inklusive aller zukünftigen Updates. Keine Abos, keine versteckten Kosten. Der Preis ist ein Bruchteil dessen, was du an Versandkosten und Fehlkäufen sparst.",
  "faq.q12": "Gibt es eine Geld-zurück-Garantie?",
  "faq.a12": "Ja, wir bieten eine 30-Tage-Geld-zurück-Garantie. Wenn du mit dem Spreadsheet nicht zufrieden bist, erhältst du dein Geld ohne Fragen zurück. Wir sind von der Qualität überzeugt und wollen, dass du kein Risiko eingehst.",
  "faq.q13": "Funktioniert das Spreadsheet auch für Österreich und die Schweiz?",
  "faq.a13": "Ja, das Spreadsheet funktioniert für alle deutschsprachigen Länder. Die Versandoptionen und Zollinformationen sind speziell auf Deutschland, Österreich und die Schweiz abgestimmt. Viele unserer Nutzer kommen aus der gesamten DACH-Region.",
  "faq.q14": "Wie erkenne ich Fake-Produkte auf OOPBuy?",
  "faq.a14": "Fake-Erkennung ist eine Kunst. Unser QC-Guide im Spreadsheet zeigt dir alle Details: Logo-Platzierung, Nahtqualität, Material, Verpackung. Mit unseren Checklisten erkennst du schlechte Reproduktionen sofort und kannst sie vor dem Versand ablehnen.",
  "faq.q15": "Warum ist das Spreadsheet besser als kostenlose Listen?",
  "faq.a15": "Kostenlose Listen sind oft veraltet, enthalten tote Links oder werben für schlechte Verkäufer. Unser Spreadsheet wird professionell gepflegt, alle Links werden monatlich geprüft und die Verkäufer sind persönlich getestet. Du sparst Stunden an Recherche und vermeidest Fehlkäufe.",
  "faq.q16": "Kann ich eigene Produkte zum Spreadsheet hinzufügen?",
  "faq.a16": "Das Spreadsheet ist schreibgeschützt, um die Qualität zu gewährleisten. Aber wir nehmen gerne Vorschläge von Nutzern entgegen. Wenn du ein tolles Produkt gefunden hast, schick uns den Link und wir prüfen es für die nächste Aktualisierung.",
  "faq.q17": "Wie kontaktiere ich den Support?",
  "faq.a17": "Du erreichst uns jederzeit über das Kontaktformular auf unserer Hauptseite. Wir antworten in der Regel innerhalb von 24 Stunden. Für dringende Fragen zum Spreadsheet haben wir auch einen Discord-Server, auf dem die Community hilft.",

  "cta.tag": "Bereit loszulegen?",
  "cta.heading1": "Hol dir jetzt das",
  "cta.heading2": "OOPBuy Spreadsheet",
  "cta.desc": "Spare Zeit, Geld und Nerven. Mit dem OOPBuy Spreadsheet hast du alle besten Produkte, Verkäufer und Guides an einem Ort. Starte noch heute und werde Teil von 15.000+ zufriedenen Nutzern.",
  "cta.button": "Jetzt kaufen auf kaspreadsheet.com",

  "footer.brand": "OOPBuy Spreadsheet",
  "footer.brand.desc": "Dein vertrauenswürdiger Guide für OOPBuy in Deutschland. Wir helfen dir, die besten Produkte zu finden und sicher einzukaufen.",
  "footer.navigation": "Navigation",
  "footer.nav.home": "Startseite",
  "footer.nav.categories": "Kategorien",
  "footer.nav.shipping": "Versand Guide",
  "footer.nav.qc": "QC Guide",
  "footer.nav.faq": "FAQ",
  "footer.social": "Social Media",
  "footer.newsletter": "Newsletter",
  "footer.newsletter.desc": "Erhalte die neuesten Updates und Angebote.",
  "footer.newsletter.placeholder": "Deine E-Mail-Adresse",
  "footer.newsletter.button": "Anmelden",
  "footer.copyright": "© 2026 OOPBuy Spreadsheet. Alle Rechte vorbehalten.",

  "navbar.categories": "Kategorien",
  "navbar.search": "Suchen",
  "navbar.cta1": "oopbuy spreadsheet",
  "navbar.cta2": "buy it now",

  "breadcrumb.home": "Startseite",
  "breadcrumb.article": "Artikel",

  "article.back": "Zurück zur Startseite",
  "article.related": "Verwandte Artikel",
  "article.toc": "Inhaltsverzeichnis",
  "article.share": "Teilen",
  "article.readtime": "Min. Lesezeit",
  "article.published": "Veröffentlicht am",
  "article.cta": "Zum OOPBuy Spreadsheet",
}